import { Controller } from "@hotwired/stimulus"

// Toggles a password field between hidden (type="password") and revealed
// (type="text"), swapping the eye icon at the same time.
//
// HTML shape expected:
//   <div data-controller="password-toggle">
//     <input type="password" data-password-toggle-target="input">
//     <button type="button" data-action="password-toggle#toggle">
//       <span data-password-toggle-target="hiddenIcon">[eye-off]</span>
//       <span data-password-toggle-target="visibleIcon" class="hidden">[eye]</span>
//     </button>
//   </div>
export default class extends Controller {
  static targets = ["input", "hiddenIcon", "visibleIcon"]

  toggle(event) {
    event.preventDefault()

    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"

    if (this.hasHiddenIconTarget) this.hiddenIconTarget.classList.toggle("hidden", isPassword)
    if (this.hasVisibleIconTarget) this.visibleIconTarget.classList.toggle("hidden", !isPassword)
  }
}
